// src/DynamicFaviconAndTitle.jsx
import React, { useEffect } from "react";
import { getBranding } from "./utils/getBranding";
// import { getBranding } from "./utils/branding"; // adjust path if needed

function DynamicFaviconAndTitle() {
  useEffect(() => {
    const branding = getBranding();

    // Set document title
    document.title = branding.brandName;

    // Remove old favicons
    const oldIcons = document.querySelectorAll("link[rel~='icon']");
    oldIcons.forEach(icon => icon.remove());

    // Add new favicon
    const newFavicon = document.createElement("link");
    newFavicon.rel = "icon";
    newFavicon.href = branding.faviconLogoOcay;
    document.head.appendChild(newFavicon);
  }, []);

  return null;
}

export default DynamicFaviconAndTitle;
